import { Pressable, Center, Text, Row, Box, IBoxProps } from 'native-base'
import { PropsWithChildren, FC, useCallback } from 'react'

import { Icon } from './Icon'

import { IconNames } from '~types/icon'
export type CheckBoxProps = {
  color?: IBoxProps['color']
  icon?: IconNames
  id: string
  isChecked?: boolean
  onPress: (slug: string) => void
  text?: string
}

export const CheckBox: FC<PropsWithChildren<CheckBoxProps & IBoxProps>> = ({
  children,
  color = 'offMain',
  icon = 'check-line',
  isChecked,
  id,
  onPress,
  text,
  ...rest
}) => {
  const onPressHandler = useCallback(() => {
    onPress(id)
  }, [id, onPress])

  return (
    <Box {...rest}>
      <Pressable onPress={onPressHandler}>
        <Row alignItems="flex-start">
          <Center
            height="6"
            width="6"
            rounded="xs"
            borderColor={isChecked ? 'actionBlue' : 'border'}
            borderWidth={2}
            borderRadius={2}
            bg={isChecked ? 'actionBlue' : 'white'}
            mt="0.5"
          >
            <Icon name={icon} size={14} color="white" />
          </Center>
          <Box pl={text ? 2 : 0} flex={1}>
            {text ? (
              <Text color={isChecked ? 'black' : color} flexWrap="wrap">
                {text}
              </Text>
            ) : (
              children
            )}
          </Box>
        </Row>
      </Pressable>
    </Box>
  )
}
